import { createStore } from 'vuex'
import OrderService from '@/services/OrderService.js'

export default createStore({
  state: {
    workSymbol: null,
    workAccount: null,
    workDate: null,
    workTenant: null,
    transactions: [],
    orders: [],
    brokerageNotes: [],
    dividends: [],
    companys: [],
    accounts: [],
    busy: false,
    symbols: [],
    tenants: [
      {
        id: "cdaf6dde-2a63-4b0e-8629-bd7e420c7485",
        name: "ALEXANDRE",
        default: true

      },      
      {
        id: "dff0a57d-4feb-4abd-a2bd-fcd337705cf9",
        name: "JESSICA",
        default: false
      },
      {
        id: "9a5e0eb4-a161-44c0-ad25-14ad043ae15d",
        name: "COMERCIAL",
        default: false
      }
    ]
  },
  mutations: {
    ApiOut (state, busy) {
      state.busy = busy
    },
    WorkSymbol (state, symbol) {
      if (symbol) { symbol = symbol.toUpperCase() }
      localStorage.setItem('WorkSymbol', symbol)
      state.workSymbol = symbol
    },
    WorkAccount (state, account) {
      if(account) {
        localStorage.setItem('WorkAccount', account)
      }
      state.workAccount = account
    },
    WorkDate (state , date) {
      localStorage.setItem('WorkData', date)
      state.workDate = date
    },
    WorkTenant (state, tenant) {
      localStorage.setItem('WorkTenant', tenant)
      state.workTenant = tenant
    },
    SetTransactions (state, transactions) {
      state.transactions = transactions
    },
    SetOrders (state, orders) {
      state.orders = orders
    },
    SetBrokerageNotes (state, notes) {
      state.brokerageNotes = notes
    },
    SetDividends (state, dividends) {
      state.dividends = dividends
    },
    AddOrUpdateOrder (state, order) {
      let i = state.orders.map(x => x.idOrder).indexOf(order.idOrder)
      if (i >= 0) {
        state.orders.splice(i, 1, order)
      } else {
        state.orders.splice(0, 0, order)
      }
    },
    OrderDeleted (state, idOrder) {
      let i = state.orders.map(x => x.idOrder).indexOf(idOrder)      
      if (i >= 0) {
        state.orders.splice(i,1)
      }
    },
    AddOrUpdateSymbol (state, symbol) {
      let i = state.symbols.map(x => x.symbol).indexOf(symbol.symbol)
      if (i >= 0) {
        state.symbols.splice(i, 1, symbol)
      } else {
        state.symbols.splice(0, 0, symbol)
      }
    },    
    SetCompanys (state, companys) {
      state.companys = companys
    },
    SetSymbols (state, symbols) {
      state.symbols = symbols
    },
    SetAccounts (state, accounts) {
      state.accounts = accounts
    },
    Busy (state, busy) {
      state.busy = busy
    },
    Unauthorized () {
      localStorage.setItem('api-key', null)
    },
    Authorize(state, apikey) {
      localStorage.setItem('api-key', apikey)      
    }
  },
  actions: {
    async UpdateOrderFromApi({ commit }, idOrder) {
      let service = new OrderService()
      var order = await service.GetOrder(idOrder)
      commit('AddOrUpdateOrder', order)
    }
  },
  getters: {
    Dividends: state => state.dividends,
    WorkAccount: state => state.workAccount ?? localStorage.getItem('WorkAccount'),
    WorkSymbol: state => state.workSymbol ?? localStorage.getItem('WorkSymbol'),
    WorkDate: state => state.workDate ?? localStorage.getItem('WorkDate'),
    WorkTenant: (state) => { return state.workTenant ?? state.tenants.filter(x => x.default === true)[0] },
    Transactions: state => state.transactions,
    Orders: state => state.orders,
    BrokerageNotes: state => state.brokerageNotes,
    Busy: state => state.busy,
    Symbols: (state) => state.symbols,
    SymbolsByCurrency: (state) => (currency) => { return state.symbols.filter(x => x.currency === currency) },
    Companys: (state) => { return state.companys },
    Authorized: () => { return localStorage.getItem('api-key') !== null},
    Tenants: (state) => { return state.tenants },
    Accounts: (state) => state.accounts
  }
})
